export const sopData = {
  recipes: [
    {
      id: 'r1',
      title: 'Classic Margherita Pizza',
      category: 'Pizza',
      lastUpdated: '2024-01-15',
      status: 'active',
      version: '2.1',
      author: 'Chef Ahmed',
      prepTime: '30 mins',
      yield: '1 pizza (12")',
      ingredients: [
        { item: 'Pizza Dough', quantity: '250g' },
        { item: 'Tomato Sauce', quantity: '100g' },
        { item: 'Fresh Mozzarella', quantity: '150g' },
        { item: 'Fresh Basil', quantity: '10g' },
        { item: 'Olive Oil', quantity: '15ml' }
      ],
      steps: [
        { step: 1, description: 'Preheat oven to 250°C' },
        { step: 2, description: 'Roll out the dough to 12 inches' },
        { step: 3, description: 'Spread tomato sauce evenly' },
        { step: 4, description: 'Add torn mozzarella pieces' },
        { step: 5, description: 'Bake for 12-15 minutes' },
        { step: 6, description: 'Garnish with fresh basil' }
      ],
      notes: 'Ensure ingredients are at room temperature',
      usedIn: ['Store 1', 'Store 2', 'Store 3']
    },
    {
      id: 'r2',
      title: 'Chicken Shawarma',
      category: 'Sandwiches',
      lastUpdated: '2024-01-18',
      status: 'active',
      version: '1.8',
      author: 'Chef Mohammed',
      prepTime: '45 mins',
      yield: '4 servings',
      ingredients: [
        { item: 'Chicken Thighs', quantity: '800g' },
        { item: 'Shawarma Spices', quantity: '30g' },
        { item: 'Garlic Sauce', quantity: '200g' },
        { item: 'Pita Bread', quantity: '4 pieces' }
      ],
      steps: [
        { step: 1, description: 'Marinate chicken with spices' },
        { step: 2, description: 'Cook on vertical rotisserie' },
        { step: 3, description: 'Slice cooked meat thinly' }
      ],
      notes: 'Marinate for at least 4 hours',
      usedIn: ['Store 1', 'Store 4', 'Store 5']
    },
    {
      id: 'r3',
      title: 'Classic Hummus',
      category: 'Appetizers',
      lastUpdated: '2024-01-20',
      status: 'active',
      version: '1.5',
      author: 'Chef Sara',
      prepTime: '20 mins',
      yield: '500g',
      ingredients: [
        { item: 'Chickpeas', quantity: '400g' },
        { item: 'Tahini', quantity: '60g' },
        { item: 'Lemon Juice', quantity: '30ml' },
        { item: 'Garlic', quantity: '15g' }
      ],
      steps: [
        { step: 1, description: 'Blend chickpeas until smooth' },
        { step: 2, description: 'Add tahini and seasonings' },
        { step: 3, description: 'Adjust consistency' }
      ],
      notes: 'Use ice cold water for smoother texture',
      usedIn: ['Store 1', 'Store 2', 'Store 3', 'Store 4']
    },
    {
      id: 'r4',
      title: 'Beef Burger Patty',
      category: 'Burgers',
      lastUpdated: '2024-01-22',
      status: 'active',
      version: '2.3',
      author: 'Chef John',
      prepTime: '25 mins',
      yield: '6 patties',
      ingredients: [
        { item: 'Ground Beef', quantity: '1kg' },
        { item: 'Burger Seasoning', quantity: '25g' },
        { item: 'Salt', quantity: '10g' },
        { item: 'Black Pepper', quantity: '5g' }
      ],
      steps: [
        { step: 1, description: 'Mix ingredients gently' },
        { step: 2, description: 'Form 180g patties' },
        { step: 3, description: 'Create thumb impression' }
      ],
      notes: 'Do not overwork the meat',
      usedIn: ['Store 2', 'Store 3', 'Store 5']
    },
    {
      id: 'r5',
      title: 'Signature House Sauce',
      category: 'Sauces',
      lastUpdated: '2024-01-25',
      status: 'active',
      version: '1.2',
      author: 'Chef Ahmed',
      prepTime: '15 mins',
      yield: '1L',
      ingredients: [
        { item: 'Mayonnaise', quantity: '500g' },
        { item: 'Secret Spice Mix', quantity: '30g' },
        { item: 'Lemon Juice', quantity: '15ml' }
      ],
      steps: [
        { step: 1, description: 'Mix all ingredients' },
        { step: 2, description: 'Rest for 2 hours' }
      ],
      notes: 'Store in airtight container',
      usedIn: ['Store 1', 'Store 2', 'Store 3', 'Store 4', 'Store 5']
    }
  ],

  manuals: [
    {
      id: '1',
      title: 'Kitchen Operations Manual',
      category: 'Operations',
      status: 'active',
      department: 'Kitchen',
      lastUpdated: '2024-01-15',
      sections: [
        {
          title: 'Introduction',
          content: 'This manual covers all standard operating procedures for kitchen operations...'
        }
        // ... more sections
      ]
    },
    {
      id: '2',
      title: 'Food Safety Guidelines',
      category: 'Safety',
      status: 'active',
      department: 'All Departments',
      lastUpdated: '2024-01-10',
      sections: [
        {
          title: 'Food Safety Basics',
          content: 'Essential guidelines for maintaining food safety standards...'
        }
        // ... more sections
      ]
    }
    // ... more manuals
  ],

  checklists: [
    {
      id: 'c1',
      title: 'Morning Opening Procedures',
      category: 'Daily Operations',
      frequency: 'daily',
      department: 'Kitchen',
      instructions: 'Complete all tasks in order. Any temperature issues must be reported immediately to management.',
      items: [
        {
          id: 1,
          task: 'Check walk-in refrigerator temperature',
          notes: 'Must be between 2-4°C. Log in temperature log.',
          required: true
        },
        {
          id: 2,
          task: 'Check freezer temperature',
          notes: 'Must be below -18°C. Log in temperature log.',
          required: true
        },
        {
          id: 3,
          task: 'Inspect prep station refrigerators',
          notes: 'Temperature between 2-4°C. Check seals and cleanliness.',
          required: true
        },
        {
          id: 4,
          task: 'Sanitize all work surfaces',
          notes: 'Use approved sanitizer solution (100ppm)',
          required: true
        },
        {
          id: 5,
          task: 'Check and refill sanitizer buckets',
          notes: 'Test with sanitizer strips',
          required: true
        },
        {
          id: 6,
          task: 'Inspect and organize mise en place',
          notes: 'Check freshness and stock levels',
          required: true
        },
        {
          id: 7,
          task: 'Check equipment functionality',
          notes: 'Ovens, ranges, fryers, and hood system',
          required: true
        },
        {
          id: 8,
          task: 'Verify staff uniform compliance',
          notes: 'Clean uniform, hairnets, and appropriate shoes',
          required: true
        }
      ]
    },
    {
      id: 'c2',
      title: 'Weekly Deep Cleaning Schedule',
      category: 'Cleaning',
      frequency: 'weekly',
      department: 'Kitchen',
      instructions: 'Use appropriate PPE when handling cleaning chemicals. Document any maintenance issues found during cleaning.',
      items: [
        {
          id: 1,
          task: 'Deep clean hood filters',
          notes: 'Soak in degreaser, scrub, and rinse thoroughly',
          required: true
        },
        {
          id: 2,
          task: 'Clean behind and under equipment',
          notes: 'Move equipment where possible, degrease floor',
          required: true
        },
        {
          id: 3,
          task: 'Descale dish machine',
          notes: 'Use approved descaler, run empty cycles after',
          required: true
        },
        {
          id: 4,
          task: 'Clean and sanitize walk-in shelving',
          notes: 'Remove all items, clean shelves, walls, and floor',
          required: true
        },
        {
          id: 5,
          task: 'Clean and sanitize prep station gaskets',
          notes: 'Check for damage or mold',
          required: true
        },
        {
          id: 6,
          task: 'Deep clean floor drains',
          notes: 'Remove covers, clean, sanitize, replace covers',
          required: true
        }
      ]
    },
    {
      id: 'c3',
      title: 'Monthly Equipment Maintenance',
      category: 'Maintenance',
      frequency: 'monthly',
      department: 'Kitchen',
      instructions: 'Document all findings and maintenance performed. Report any issues requiring professional service.',
      items: [
        {
          id: 1,
          task: 'Inspect and clean refrigeration coils',
          notes: 'Use coil cleaner and compressed air',
          required: true
        },
        {
          id: 2,
          task: 'Check and lubricate door hinges',
          notes: 'All cooler and freezer doors',
          required: true
        },
        {
          id: 3,
          task: 'Calibrate oven temperatures',
          notes: 'Use calibrated thermometer, adjust as needed',
          required: true
        },
        {
          id: 4,
          task: 'Inspect gas connections',
          notes: 'Check for leaks using soap solution',
          required: true
        },
        {
          id: 5,
          task: 'Test emergency shut-off systems',
          notes: 'Gas, electrical, and fire suppression',
          required: true
        }
      ]
    },
    {
      id: 'c4',
      title: 'Food Safety Audit Checklist',
      category: 'Food Safety',
      frequency: 'weekly',
      department: 'All Departments',
      instructions: 'Any critical violations must be corrected immediately and reported to management.',
      items: [
        {
          id: 1,
          task: 'Verify HACCP documentation',
          notes: 'All logs current and properly filled',
          required: true
        },
        {
          id: 2,
          task: 'Check employee hygiene practices',
          notes: 'Hand washing, glove use, proper attire',
          required: true
        },
        {
          id: 3,
          task: 'Inspect food storage temperatures',
          notes: 'All items within safe temperature range',
          required: true
        },
        {
          id: 4,
          task: 'Verify proper food labeling',
          notes: 'Dates, contents, and allergen information',
          required: true
        },
        {
          id: 5,
          task: 'Check chemical storage',
          notes: 'Proper separation from food items',
          required: true
        }
      ]
    }
  ],

  announcements: [
    {
      id: 'a1',
      title: 'New Menu Items Launch',
      content: 'We are excited to announce the launch of 5 new menu items starting next week. All staff must complete the new recipes training by Friday.',
      priority: 'high',
      department: 'All Departments',
      date: '2024-01-25',
      author: 'Sarah Johnson',
      status: 'active',
      views: 156,
      acknowledgments: 45,
      comments: 12,
      attachments: [
        { name: 'New_Menu_Items.pdf', type: 'pdf' },
        { name: 'Training_Schedule.pdf', type: 'pdf' }
      ]
    },
    {
      id: 'a2',
      title: 'Updated Safety Protocols',
      content: 'Important updates to our safety protocols have been implemented. Please review the attached documents and acknowledge receipt.',
      priority: 'high',
      department: 'Operations',
      date: '2024-01-23',
      author: 'Mike Chen',
      status: 'active',
      views: 234,
      acknowledgments: 89,
      comments: 8,
      attachments: [
        { name: 'Safety_Protocols_2024.pdf', type: 'pdf' }
      ]
    },
    {
      id: 'a3',
      title: 'Staff Meeting Schedule - February',
      content: 'Monthly staff meeting schedule for February has been finalized. Please check the attached schedule for your department.',
      priority: 'medium',
      department: 'All Departments',
      date: '2024-01-20',
      author: 'Lisa Wong',
      status: 'active',
      views: 123,
      acknowledgments: 67,
      comments: 5,
      attachments: [
        { name: 'Feb_Meeting_Schedule.pdf', type: 'pdf' }
      ]
    },
    {
      id: 'a4',
      title: 'System Maintenance Notice',
      content: 'POS system will undergo maintenance on Sunday night. Please complete all end-of-day procedures before 11 PM.',
      priority: 'medium',
      department: 'Operations',
      date: '2024-01-18',
      author: 'IT Department',
      status: 'active',
      views: 189,
      acknowledgments: 78,
      comments: 3
    },
    {
      id: 'a5',
      title: 'Employee of the Month',
      content: 'Congratulations to Ahmed Hassan for being selected as Employee of the Month for January 2024!',
      priority: 'low',
      department: 'All Departments',
      date: '2024-01-15',
      author: 'HR Department',
      status: 'active',
      views: 245,
      acknowledgments: 156,
      comments: 22,
      attachments: [
        { name: 'Achievement_Certificate.pdf', type: 'pdf' }
      ]
    }
  ],

  stats: {
    totalRecipes: 45,
    totalManuals: 38,
    totalChecklists: 41,
    activeAnnouncements: 12,
    recentUpdates: 8,
    pendingAcknowledgments: 5
  }
}; 